/**
 * TTPEcommerceWidget — Backward-compatible alias.
 *
 * Creates a TTPChatWidget with flavor.type='ecommerce'.
 * Existing embedders using TTPEcommerceWidget continue to work without changes.
 *
 * Usage:
 *   const widget = new TTPEcommerceWidget({
 *     agentId: 'your_agent',
 *     appId: 'your_app',
 *     partner: { name: 'Shufersal' }
 *   });
 */
import { TTPChatWidget } from '../widget/TTPChatWidget.js';

export class TTPEcommerceWidget extends TTPChatWidget {
  constructor(config = {}) {
    super({
      ...config,
      flavor: config.flavor || {
        type: 'ecommerce',
        partnerId: config.partner?.name,
        shopifyDomain: config.partner?.shopifyDomain,
      },
    });
  }
}
